// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1mN1x","label":"CategoryService_label__18jIU","location":"CategoryService_location__3s80T"};